import PropTypes from 'prop-types';
import React from 'react';

export const formatCost = amount => `$${amount.toFixed(2)}`;

const Cost = ({amount}) => <span>{formatCost(amount)}</span>;

Cost.propTypes = {
  amount: PropTypes.number.isRequired,
  currencyCode: PropTypes.oneOf(['USD']).isRequired,
};

export default Cost;



// WEBPACK FOOTER //
// ./src/common/components/Cost/Cost.js